<div class="card border-0 shadow-sm">
  <div class="card-body">
    <div  class="Chartcontainerx">
      <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptionsGroups">
      </highcharts-chart>
    </div>
  </div>
</div>
